<style>
/* @import "https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css"; */

#main {
  float: left;
  text-align: left;
  width: 100%;
  padding: 30px;
}
p{
  margin: 0;
}
.w100 {
  width:100%;
}
#startMission{
  margin-right:10px;
}
#logout {
  position: absolute;
  top: 30px;
  right: 150px;
}
.v-selection-control__input:hover::before {
  opacity: 0.2 !important;
}
.v-slide-group__container .v-btn:hover > .v-btn__overlay {
  opacity: 0.2 !important;
}
</style>
<template>
  <v-app>
    <Appbar :title="`${greet} <strong>${usernamelogin}</strong>`"></Appbar>
    <v-main>
  <div class="WellCome">
    <div class="container">
      <!-- <i class="fa-regular fa-square-check text-success"></i>
      <i class="fa-regular fa-rectangle-xmark text-danger"></i> -->
      <!-- <button
        type="button"
        id="logout"
        class="btn btn-primary"
        v-on:click="logout1"
      >
        {{ $t("message.logout", {}, { locale: lang }) }}
      </button> -->
      <div class="main" id="main">
        <!-- <h4>
          {{ $t("message.hello", {}, { locale: lang }) }}:
          <b id="usernamelogin">{{ usernamelogin }}</b>
        </h4> -->
        <h5>{{ $t("message.greetings", {}, { locale: lang }) }}</h5>
        <br><br>
        <button class="btn btn-primary" id="startMission" v-on:click="gotoConnectDevice">
          <h5>
            <b>{{ $t("message.startmission", {}, { locale: lang }) }}</b>
          </h5>
          <p>{{ $t("message.startmission1", {}, { locale: lang }) }}</p>
        </button>
        <a class="btn btn-primary" id="viewMission" href="/history" >
          <h5>
            <b>{{ $t("message.reviewmission", {}, { locale: lang }) }}</b>
          </h5>
          <p>{{ $t("message.reviewmission1", {}, { locale: lang }) }}</p>
        </a>
      </div>
    </div>
    
  </div>
</v-main>
</v-app>
</template>

<script src="./welcome-user-view"></script>
